import React from "react";
import moment from "moment";

const ACTION_LABELS = {
  release_results: "Release Results",
  contact_csm: "Contact CSM",
  send_new_sample: "Send New Sample",
};

export const isActionRead = (value) => (
  value === true || value === "true" || value === 1 || value === "1"
);

export const displayCell = (value) => {
  if (value == null || String(value).trim() === "") return "-";
  return String(value);
};

export const formatActionAt = (value) => {
  if (value == null || value === "") return "-";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY, h:mm:ss a") : "-";
};

export const actionLabelFor = (record) => (
  record.action_label || ACTION_LABELS[record.action_type] || displayCell(record.action_type)
);

const namedValue = (value) => {
  if (value == null || String(value).trim() === "") return "";
  return String(value).trim();
};

const userNameFromRecord = (record, userNames) => {
  const directName = namedValue(record.read_by_user_name || record.read_by_name);
  if (directName) return directName;
  if (record.read_by_user_id == null || record.read_by_user_id === "") return "";
  return userNames[record.read_by_user_id] || userNames[String(record.read_by_user_id)] || "";
};

export const esvDoneAtLabel = (record) => formatActionAt(record?.read_at);

export const esvDoneByLabel = (record, userNames = {}) => userNameFromRecord(record, userNames) || "-";

export const readStatusTooltip = (record, userNames = {}) => {
  const read = isActionRead(record?.is_read);
  return (
    <span>
      {read ? "Marked as read" : "Marked as unread"}
      <br />
      {`Marked at: ${esvDoneAtLabel(record)}`}
      <br />
      {`Marked by: ${esvDoneByLabel(record, userNames)}`}
    </span>
  );
};
